module.exports = require("@gauzy/plugin-integration-hubstaff");